require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-campaign-البيية-والمناخ.json") })
        }
      }, "path---ar-eg-campaign-البيية-والمناخ");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-campaign-البيية-والمناخ!./.cache/json/ar-eg-campaign-البيية-والمناخ.json
// module id = 425
// module chunks = 231608221292675